module.exports = __webpack_public_path__ + "static/media/home-icon.684a681c.svg";